import cn from 'classnames';
import React, { FC, memo } from 'react';

import { isFirstMonthAfterAdd } from '@helpers/vaults/date.helpers';

import { toBN } from '@utils/formaters.utils';

import Tag from '@components/common/Tag';

import { PERCENT_DIVIDER } from '@constants/common/common.constants';
import { TagType } from '@constants/common/tag.constants';
import { TokenType, V3_TOKENS_TYPE } from '@constants/vaults/tokens.constants';

import useStyles from './styles.module';

interface FarmsTagsProps {
  dateOfAdd?: string;
  stakingTokenType: TokenType;
  poolFee?: number;
  className?: string;
}

const FarmTags: FC<FarmsTagsProps> = ({
  dateOfAdd,
  stakingTokenType,
  poolFee,
  className,
}) => {
  const { classes } = useStyles();

  return (
    <div className={cn(classes.tags, className)}>
      {dateOfAdd && isFirstMonthAfterAdd(dateOfAdd) && (
        <Tag type={TagType.NEW} />
      )}

      {V3_TOKENS_TYPE.includes(stakingTokenType) && (
        <Tag
          type={TagType.V3}
          value={toBN(poolFee || 0).times(PERCENT_DIVIDER)}
        />
      )}
    </div>
  );
};

export default memo(FarmTags);
